var _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgMachineDetails(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 100,
    height: 100,
    fill: "none",
    viewBox: "0 0 192 192",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    stroke: "#1D71B8",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 12,
    d: "M120 54H72m48 24H72m78 28V30a6 6 0 0 0-6-6H48a6 6 0 0 0-6 6v132a6 6 0 0 0 6 6h46.5"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#1D71B8",
    d: "M96 144a9 9 0 0 0 9-9 9 9 0 0 0-9-9 9 9 0 0 0-9 9 9 9 0 0 0 9 9Z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#1C71B8",
    d: "M146.5 133c-21.786 0-30.5 19.5-30.5 19.5s8.714 19.5 30.5 19.5 30.5-19.5 30.5-19.5-8.714-19.5-30.5-19.5Zm0 30.333c-2.154 0-4.26-.635-6.052-1.825a10.859 10.859 0 0 1-4.012-4.862 10.785 10.785 0 0 1 2.362-11.806 10.91 10.91 0 0 1 5.577-2.965 10.95 10.95 0 0 1 6.294.616c1.99.82 3.691 2.209 4.888 3.99a10.792 10.792 0 0 1 1.836 6.019c0 2.873-1.148 5.629-3.191 7.66a10.92 10.92 0 0 1-7.702 3.173Z",
    opacity: 0.2
  }), /*#__PURE__*/React.createElement("path", {
    stroke: "#1C71B8",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 6,
    d: "M146.5 133c-21.786 0-30.5 19.5-30.5 19.5s8.714 19.5 30.5 19.5 30.5-19.5 30.5-19.5-8.714-19.5-30.5-19.5Z"
  }), /*#__PURE__*/React.createElement("path", {
    stroke: "#1C71B8",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 6,
    d: "M147 163c6.075 0 11-4.701 11-10.5s-4.925-10.5-11-10.5-11 4.701-11 10.5 4.925 10.5 11 10.5Z"
  }))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgMachineDetails);
export default __webpack_public_path__ + "static/media/MachineDetails.0f34407f2f48251bb35f13790ed10b5e.svg";
export { ForwardRef as ReactComponent };